import { ListingEditorPage } from './ListingEditor';

export function BranchCreatePage() {
  return <ListingEditorPage branchCreation />;
}
